export default {
    data() {
        return {
            pagination: {
                status: {
                    current_page: 1,
                    last_page: null,
                },
                options: {
                    previousText: 'Forrige',
                    nextText: 'Næste',
                    alwaysShowPrevNext: true,
                },
            },
        }
    },

    methods: {
        paginate(response) {
            this.pagination.status = response.meta

            return response
        },
    },

    computed: {
        page: {
            get() {
                return this.pagination.status.current_page
            },
            set(page) {
                this.pagination.status.current_page = page
            },
        },
        pages() {
            return this.pagination.status.last_page
        },
    },
}
